import { render, staticRenderFns } from "./PersonalizedDebt.vue?vue&type=template&id=ecab29c2&scoped=true&"
import script from "./PersonalizedDebt.vue?vue&type=script&lang=js&"
export * from "./PersonalizedDebt.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizedDebt.vue?vue&type=style&index=0&id=ecab29c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecab29c2",
  null
  
)

export default component.exports